var _defs, _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanetShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354 248",
    width: 354,
    height: 248,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    id: "f1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{filter:url(#f1);fill:#1975c9}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m193.9 175.7c-63.8 20.7-122.9 14.3-132.2-14.3-9.2-28.5 34.9-68.3 98.7-89 63.8-20.7 122.9-14.3 132.2 14.2 9.2 28.6-34.9 68.4-98.7 89.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetShadow);
export default __webpack_public_path__ + "static/media/PlanetShadow.ba19e1d0ff6e93580813b41379277702.svg";
export { ForwardRef as ReactComponent };